import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Owner's Equity accounts with each owner's shared percentage
export const getOwnerEquityAccounts = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/profit_distribution/getOwnerEquityAccounts`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
